<template>
  <div class="search">
    <div class="banner-top">
      <div class="banner-box"></div>
      <div class="banner-desc">搜索-->{{keyword}}</div>
    </div>
    <div class="search-box">
      <div class="list">
        <div class="list-box" v-for="(item,i) in itemList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.mid+'&catname='+item.name">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getSearchListMore">点击加载更多...</div>
          </div>
        </div>
      </div>
    </div>

    <div class="back-top" @click="backTop" v-show="btnFlag">
      <img src="../assets/images/return_top.png" alt="" srcset="">
    </div>
  </div>
</template>

<script>
import { SearchList } from "@/api/news";
export default {
  name: "Search",
  data() {
    return {
      itemList: [],
      page: 1,
      btnFlag: false,
      keyword: this.$route.query.keyword,
    }
  },
  created() {
    this.getSearchList()
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    getSearchList() {
      SearchList({keyword: this.keyword, page: this.page}).then((response) => {
        if (response.code === 200) {
          this.itemList = this.itemList.concat(response.data)
        }
      });
    },
    getSearchListMore() {
      this.page++;
      this.getSearchList()
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  }
}
</script>

<style scoped>
.search {
  background-color: #F5F7FA;
}
.search-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 100px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}
.cursorPointer {
  cursor: pointer;
}

.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue